import { EntityRepository } from '@record-it-npm/synchro-client';
import { useCallback } from 'react';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../../classes/entities/AppEntityManagerEntityTypesByEntityName';
import { useEntityRepository } from './useEntityRepository';

/**
 * provides a callback with which you can modify entities for the given EntityName
 */
export function useModifyEntityCallback<TEntityName extends EntityName>(
  entityName: TEntityName
): ModifyEntityCallback<
  AppEntityManagerEntityTypesByEntityName[TEntityName]['entity']
> {
  const repository = useEntityRepository(entityName) as EntityRepository<
    any,
    any,
    any
  >;

  return useCallback(
    (entity, key, value) => {
      entity[key] = value;
      repository.update(entity);
    },
    [repository]
  );
}

export type ModifyEntityCallback<TEntity> = <TKey extends keyof TEntity>(
  entity: TEntity,
  key: TKey,
  value: TEntity[TKey]
) => void;
